/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import LangMenu from "./modules/LangMenu";
import ScrollHeader from "./modules/ScrollHeader";
import MobileMenu from "./modules/MobileMenu";
import SwiperSliders from "./modules/SwiperSliders";
import CategoriesHover from "./modules/CategoriesHover";
import SectionInstagram from "./modules/SectionInstagram";
import BannerStatic from "./modules/BannerStatic";
import OurHistory from "./modules/OurHistory";
import Lightbox from "./modules/Lightbox";
import Select2 from "./modules/Select2";
import GiveawayTooltips from "./modules/GiveawayTooltips";
import ProductCategoriesFilter from "./modules/ProductCategoriesFilter";
import ProductCategoriesPopups from "./modules/ProductCategoriesPopups";
import ActivateAOS from "./modules/AOS";
import LenisInit from "./modules/Lenis";
import BannerVideo from "./modules/BannerVideo";
import FormFileUpload from "./modules/FormFileUpload";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const myLangMenu = new LangMenu();
    const scrollHeader = new ScrollHeader();
    const mobileMenu = new MobileMenu();
    const swiperSliders = new SwiperSliders();
    const categoriesHover = new CategoriesHover();
    const sectionInstagram = new SectionInstagram();
    const bannerStatic = new BannerStatic();
    const ourHistory = new OurHistory();
    const lightbox = new Lightbox();
    const select2 = new Select2();
    const giveawayTooltips = new GiveawayTooltips();
    const productCategoriesFilter = new ProductCategoriesFilter();
    const productCategoriesPopups = new ProductCategoriesPopups();
    const activateAOS = new ActivateAOS();
    const lenisInit = new LenisInit();
    const formFileUpload = new FormFileUpload();
    const bannerVideo = new BannerVideo();
});
